import {
	Link,
	Outlet,
	createRootRoute,
	useNavigate,
	useLocation,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import * as React from "react";
import { HeaderImage } from "../components/HeaderImage";
import { LoginModal } from "../components/auth/LoginModal";
import { HeaderImagesProvider } from "../contexts/HeaderImagesContext";

export const Route = createRootRoute({
	component: RootComponent,
});

function RootComponent() {
	const [showLoginModal, setShowLoginModal] = React.useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const handleNavigation = (path: string) => {
		navigate({
			to: path,
			search: location.search,
		});
	};

	// Pokud je to prezentační stránka, vykresli pouze obsah bez layoutu
	if (location.pathname === "/presentation") {
		return (
			<HeaderImagesProvider>
				<Outlet />
				<TanStackRouterDevtools />
			</HeaderImagesProvider>
		);
	}

	return (
		<HeaderImagesProvider>
			<>
				{/* Header s prezentací fotek */}
				<header className="relative h-[40vh] min-h-[300px] overflow-hidden">
					<div className="flex h-full">
						{/* První obrázek - viditelný na všech zařízeních */}
						<div className="w-full md:w-1/2 lg:w-1/3">
							<HeaderImage initialIndex={1} />
						</div>

						{/* Druhý obrázek - viditelný od tabletů výše */}
						<div className="hidden md:block md:w-1/2 lg:w-1/3">
							<HeaderImage initialIndex={2} />
						</div>

						{/* Třetí obrázek - viditelný pouze na velkých obrazovkách */}
						<div className="hidden lg:block lg:w-1/3">
							<HeaderImage initialIndex={3} />
						</div>
					</div>

					{/* Navigace */}
					<nav className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
						<div className="container mx-auto">
							<div className="flex flex-wrap justify-center gap-4 md:gap-8">
								<button
									type="button"
									onClick={() => handleNavigation("/")}
									className="text-white hover:text-[#98FB98] transition-colors text-base md:text-lg italic tracking-wider"
								>
									Úvod
								</button>
								<button
									type="button"
									onClick={() => handleNavigation("/gallery")}
									className="text-white hover:text-[#98FB98] transition-colors text-base md:text-lg italic tracking-wider"
								>
									Galerie
								</button>
								<button
									type="button"
									onClick={() => handleNavigation("/story")}
									className="text-white hover:text-[#98FB98] transition-colors text-base md:text-lg italic tracking-wider"
								>
									O nás
								</button>
								<button
									type="button"
									onClick={() => handleNavigation("/rsvp")}
									className="text-white hover:text-[#98FB98] transition-colors text-base md:text-lg italic tracking-wider"
								>
									Potvrzení účasti
								</button>
							</div>
						</div>
					</nav>
				</header>

				{/* Hlavní obsah */}
				<main className="min-h-[60vh]">
					<Outlet />
				</main>

				{/* Footer */}
				<footer className="bg-[#C1E1C1]/30 py-8 mt-16">
					<div className="container mx-auto px-4 text-center text-gray-600">
						<p>© 2025</p>
						<a
							href="https://lowcost-traveling.com"
							target="_blank"
							rel="noopener noreferrer"
							className="text-gray-600 hover:text-[#98FB98] transition-colors text-sm mt-2 inline-block"
						>
							lowcost-traveling.com
						</a>
					</div>
				</footer>

				{/* Login Modal */}
				<LoginModal
					isOpen={showLoginModal}
					onClose={() => setShowLoginModal(false)}
					onSuccess={() => setShowLoginModal(false)}
				/>

				<TanStackRouterDevtools />
			</>
		</HeaderImagesProvider>
	);
}
